import React, {useState} from "react";
import Modal from "react-modal";
import {FaTimes} from "react-icons/fa";
import {RiSafe2Line} from "react-icons/ri";
import {
  BASE_URL,
  crearContenedoresBL,
  procesarArchivoBL
} from "../../../../../helpers/Api";
import Dropzone from "react-dropzone-uploader";
import Swal from "sweetalert2";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {
  CampoSelectTipoContenedorAsync
} from "../../../../../helpers/CampoSelectTipoContenedorAsync";

const PDFUploader = ({ setFile, idSolicitud, token }) => {

  const [refresh, setRefresh] = useState(false);

  const getUploadParams = async ({file, meta}) => {
    const body = new FormData();
    body.append('file', file);
    body.append('solicitud_id', idSolicitud);
    const headers  = { 'Authorization': `Token ${token}` }
    return {url : `${BASE_URL}/api/v1/archivo/`, body,  headers}
  };

  const handleChangeStatus = ({ file, meta }, status) => {
    if (status === 'done') {
      setFile(file.name);
    }

    setRefresh(!refresh);
  };

  return (
    <Dropzone
      getUploadParams={getUploadParams}
      onChangeStatus={handleChangeStatus}
      maxFiles={1}
      multiple={false}
      canCancel={false}
      inputContent={'Da click o arraste el archivo pdf que desea adjuntar'}
      styles={{
        dropzone: {
          borderRadius: '5px',
          backgroundColor: '#fafafa',
          height: '50%',
          width: '80%'
        },
      }}
      accept='.pdf,.PDF'
    />
  );
}

const FormBL = ({idSolicitud, setIsUploadFile, setContainers}) => {
  const [file, setFile] = useState("");
  const token = localStorage.getItem('token');

  const handleProcessFile = async () => {
    try {
      const response = await procesarArchivoBL(file, idSolicitud, token)
      if (response.status === 200) {
        setIsUploadFile(false)
        setContainers(response.data)
      }
    } catch (err) {
      console.log(err);
      const message = "Ha ocurrido un error al procesar el archivo";
      Swal.fire('Oops', message, 'error');
    }
  };


  return <>
    <div className="row d-flex justify-content-center">
        <div className="col-10 mt-2">
          <>
            <div className="row d-flex justify-content-center">
              <div className="col-12">
                <h5 className="modalConfig_fontInstructions">
                  Subir mediante PDF archivo BL.
                </h5>
                <p className="modalConfig_fontInstructions mb-2">
                  De momento solo se permiten archivos PDF. <strong>( con BL's NO escaneados )</strong>
                  y de la naviera <strong>HAPAG LLOYD</strong>, Se puede descargar el siguiente formato
                  de ejemplo
                  <button
                    className="btn"
                    onClick={() => {
                      window.open(
                        "/staticfiles/sample_pdf.pdf",
                        "_blank"
                      );
                    }}
                    style={{ color: "green" }}
                  >
                    <u>
                      Archivo PDF
                    </u>
                  </button>
                </p>
              </div>

              <div className="col-10 mt-5">
                <PDFUploader
                  setFile={setFile}
                  idSolicitud={idSolicitud}
                  token={token}
                />
              </div>
              <div className="col-8 d-flex flex-row-reverse mt-4">
                <button
                  onClick={() => {
                    handleProcessFile();
                  }}
                  className="btn btn-primary mt-4"
                >
                  Guardar
                </button>
              </div>
            </div>
          </>
        </div>
      </div>
  </>

}

function createInitialData(containers){

  const dictData = {
    "dias_libre_demora": 7,
  }
  containers.forEach((value, index) => {
    const numeroIndex = `numero_${index}`
    const contenedorIndex = `contenedor_${index}`
    dictData[numeroIndex] = value.nombre_contenedor
    dictData[contenedorIndex] = {
      "label": value.tipo_descripcion,
      "value": value.tipo,
    }
  })

  return dictData

}

const RowContainer = ({index, setFieldValue, values}) => {
  const numberContainer = `numero_${index}`
  const typeContainer = `contenedor_${index}`

  return <div className="row mb-2 mt-2">
    <div className="col-7">
      <Field type="text" name={numberContainer} className="form-control" />
        <ErrorMessage name={numberContainer} component="p" className="requiredField" />
    </div>
    <div className="col-5">
      <CampoSelectTipoContenedorAsync
                  name={typeContainer}
                  onChange={setFieldValue}
                  selectedValue={values[typeContainer]}
                  naviera={"HAP"}
                  placeholder="Seleccione el tipo" />
    </div>
  </div>
}

function parseSendContainers(values, containersOriginal){
  return containersOriginal.map((value, index) => {
    const dictValue = {}
    const numeroIndex = `numero_${index}`
    const contenedorIndex = `contenedor_${index}`
    dictValue["numero"] = values[numeroIndex]
    dictValue["tipo"] = values[contenedorIndex].value
    dictValue["dias_libre_demora"] = values.dias_libre_demora
    return dictValue
  })
}

const FormContainers = ({containers, setIsUploadFile, idSolicitud, token}) => {

  const handleCreateContainers = async (values) => {
    try {
      const containersSend = parseSendContainers(values, containers)
      const response = await crearContenedoresBL(containersSend, idSolicitud, token)
      if (response.status === 201) {
        Swal.fire({
          position: 'center-center',
          icon: 'success',
          title: 'Contenedores creados exitosamente',
          showConfirmButton: false,
          timer: 1500
        })
        setTimeout(() => {
          window.location.reload();
        }, "1000");
      }
      setIsUploadFile(false)
    } catch (err) {
      console.log(err);
      const message = "Ha ocurrido un error al enviar los contenedores";
      Swal.fire('Oops', message, 'error');
    }
  };

  /**
   * Se valida que los contenedores no estén vacios
   */
  const validateFunction= (values)=>{
    const errors = {};

    containers.forEach((value, index) => {
      if(values[`numero_${index}`] === ""){
        errors[`numero_${index}`] = 'Campo requerido';
      }
    })

    if(values.dias_libre_demora === ""){
      errors.dias_libre_demora = 'Campo requerido';
    }

    return errors;
  };


  return <>
    {containers.length > 0 &&
    <Formik
      enableReinitialize="true"
      initialValues={createInitialData(containers)}
      validate={validateFunction}
      onSubmit={(values, {resetForm}) => {
        handleCreateContainers(values)
      }}
    >
        {({ values, setFieldValue, errors, touched, handleChange }) => (
          <Form>
            <>

              <div className="col-12 mb-4">
                <p>Se ha encontrado la siguiente información , puedes revisarla para guardarla</p>
              </div>
              <div className="col-12 mb-4">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Días libres de demora
                </label>
                <Field
                  type="number"
                  name="dias_libre_demora"
                  className="form-control"
                />
                <ErrorMessage
                  name="dias_libre_demora"
                  component="p"
                  className="requiredField"
                />
              </div>
              <h6 className=" mb-1 ">
                Contenedores encontrados
              </h6>
              {containers.map((value, index) => (
                <RowContainer setFieldValue={setFieldValue} key={index} index={index}
                              values={values}/>
              ))}
            </>
            <div className="col-12 d-flex flex-row-reverse mt-4">

              <button
                type="submit"
                className="btn btn-primary mt-4"
              >
                Guardar
              </button>
              <button
                type="button"
                onClick={() => {
                  setIsUploadFile(true)
                }}
                className="btn btn-danger mt-4 me-2"
              >
                Cancelar
              </button>
            </div>
          </Form>
        )}
    </Formik>}
    {containers.length === 0 &&
      <>
        <h6 className=" mb-1 ">
          No se encontraron contenedores en el archivo
        </h6>
        <button onClick={setIsUploadFile} className={"btn btn-primary mt-4 me-2"}>
          Volver a intentar
      </button>
      </>
    }
  </>

}


const FormSelector = ({idSolicitud, close, token}) => {
  const [isUploadFile, setIsUploadFile] = useState(true);
  const [containers, setContainers] = useState([]);
  return <>
    {isUploadFile ? <FormBL idSolicitud={idSolicitud} setContainers={setContainers}
                            close={close}
                            setIsUploadFile={setIsUploadFile}/> :
      <FormContainers containers={containers} setIsUploadFile={setIsUploadFile} token={token} idSolicitud={idSolicitud}/>}
  </>
}

export const ModalAgregarBL = ({
  open, close, idSolicitud, token
}) => {

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      width: "50%",
      height: "55%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "linear-gradient(141.48deg, #DBFBFF -2.31%, #DBE9FF 101.54%)",
      borderRadius: "5px",
      border: "none",
      boxShadow: "0px 11px 30px 12px rgba(0, 0, 0, 0.04)",
    },
    overlay: { zIndex: 1000 },
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={close}
      style={customStyles}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <div className="row m-1">
        <div className="col-12  d-flex flex-row-reverse">
          <button className="btn" onClick={close}>
            <FaTimes style={{ color: "#F47777" }} />
          </button>
        </div>
      </div>
      <div className="row addContainer">
        <div className="col-12 mb-4 d-flex align-items-start">
          <RiSafe2Line size={"1.4rem"} />{" "}
          <h6 style={{ paddingLeft: "0.5rem", marginTop: "2px" }}>
            Agregar BL
          </h6>
        </div>
        <FormSelector idSolicitud={idSolicitud} close={close} token={token}/>
      </div>
    </Modal>
  );
};
